module.exports = __webpack_public_path__ + "img/LZDS-FlashExpress-DOF.81f4532b.jpg";